import { useMemo, useState } from 'react'
import { NEAR_TERM_BUCKETS, TIME_BUCKETS, timeBucket } from '../../lib/championships.js'

// One scope for the period controls, selection, and export. Never page it.
export function scopeWorklistRows(items, active, now) {
  return items.filter(row => active.has(timeBucket(row, now)))
}
export default function useWorklistScope(items, view, now) {
  const [active, setActive] = useState(() => new Set(NEAR_TERM_BUCKETS))
  const rows = useMemo(() => view === 'worklist' ? scopeWorklistRows(items, active, now) : items, [items, view, active, now])
  const label = view === 'worklist'
    ? `Worklist periods: ${TIME_BUCKETS.filter(bucket => active.has(bucket.key)).map(bucket => bucket.label).join(', ') || 'none'}. Past periods use held date; future periods use effective date. Hidden periods are excluded, including previously checked rows.`
    : ''
  return { active, setActive, rows, label }
}
